<template>
  <div> 
    <UserPassword />
  </div>
</template>

<script>
import UserPassword from '@/components/backend/user/UserPassword.vue'
export default {
  name: 'UserResetPasswordView',
  components:{
      UserPassword
  },
  data: () => {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>

.app-footer {
  box-shadow: 0 0 15px 0 rgba(0,0,0,.04)!important;
}

.small-text {
  color: #73818f;
}

.h1 {
  margin-bottom: 0rem !important;
}

</style>
